import React, { Suspense } from 'react';
const QRLogin = React.lazy(() => import('components/login/QRLogin'));

const LoginWrapper = () => {
  return <Suspense fallback={<div></div>}>
  <QRLogin />
</Suspense>;
};

export default LoginWrapper;